export default "__VITE_ASSET__B$Ok86JZ__"